import { Container, Grid, Paper, Typography, Card } from "@mui/material";

import AnalyticsDashboard from "../DataComponents/AnalyticsDashboard";
import Rankings from "../../Components/Rankings";
import { useEffect, useState } from "react";
import axios from "axios";

// Define the interface for dataSalesaccount
interface DataSalesaccount {
  total_events: number;
  foottraffic_per_hour: number;
  tasters_per_hour: number;
  sales_per_hour: number;
  product_data: {
    product_id: number | null;
    product: string | null;
    sales: number | null;
  }[];
}

const Analyticsaccount = () => {
  const [salesOverviewData, setSalesOverviewData] = useState<any[]>([]);
  const [rankings, setRankings] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const accountId = 1;
        const overviewResponse = await axios.get<DataSalesaccount>(
          `${import.meta.env.VITE_API_URL}/analytics/data_sales_account`,
          {
            params: { accountId },
          }
        );

        // Check if data is undefined or empty
        if (!overviewResponse.data) {
          setSalesOverviewData([]);
          setRankings([]);
          return;
        }

        const overviewData = overviewResponse.data;

        // Prepare the dashboard data as an array of objects
        const dashboardData = [
          { label: "# Events", value: overviewData.total_events },
          {
            label: "Foot Traffic/Hour",
            value: Math.round(overviewData.foottraffic_per_hour * 10) / 10,
          },
          {
            label: "Hourly Foottraffic",
            value: Math.round(overviewData.tasters_per_hour * 10) / 10,
          },
          {
            label: "Sales Per Hour",
            value: Math.round(overviewData.sales_per_hour * 10) / 10,
          },
        ];

        setSalesOverviewData(dashboardData);

        // Process product_data for rankings
        let productData = overviewData.product_data;

        if (Array.isArray(productData)) {
          const sortedRankings = productData
            .filter(
              (product) => product.sales !== null && product.product !== null
            ) // Filter out null sales and products
            .sort((a, b) => (b.sales || 0) - (a.sales || 0))
            .map((product, index) => ({
              rank: index + 1,
              product: product.product,
              sales: product.sales,
            }))
            .slice(0, 10); // Get only the top 10 products

          setRankings(sortedRankings);
        } else {
          console.error("product_data is not an array:", productData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setSalesOverviewData([]);
        setRankings([]);
      }
    };

    fetchData();
  }, []);

  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {salesOverviewData.length > 0 ? (
            <AnalyticsDashboard
              data={salesOverviewData}
              title="Sampling Performance Metrics"
            />
          ) : (
            <Card
              elevation={3}
              sx={{
                p: 4,
                backgroundColor: "background.paper",
                borderRadius: 2,
                textAlign: "center",
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="h5" color="text.secondary">
                No Data Available
              </Typography>
            </Card>
          )}
        </Grid>

        {salesOverviewData.length > 0 && (
          <Grid item xs={12}>
            {rankings.length > 0 && (
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  backgroundColor: "background.paper",
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6">Top Products</Typography>
                <Rankings
                  columns={[
                    { id: "rank", label: "Rank" },
                    { id: "product", label: "Product" },
                    { id: "sales", label: "Sales" },
                  ]}
                  data={rankings}
                />
              </Paper>
            )}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default Analyticsaccount;
